import '../css/style.scss'
import './libs/modernizr.js'
import './navigation.js'
import './menu.js'
import lozad from 'lozad';

const imgObserver = new lozad();
loadStyles().then(r => {});

async function loadStyles() {
  await import(
        /* webpackMode: "lazy" */
        /* webpackPreload: true */
        /* webpackChunkName: "mainImage" */
        '../css/mainImage.scss'
        );
  await sleep(100);
  await import(
    /* webpackMode: "lazy" */
    /* webpackPreload: true */
    /* webpackChunkName: "about" */
    '../css/about.scss'
  ).then(() => {
    
    imgObserver.observe();

    new Promise((resolve) => {
      require.ensure(['./libs/owl.carousel.min.js'], () => {
        resolve(require('./libs/owl.carousel.min.js'));
      }, 'owl.carousel.min');
    }).then(() => {
        $('#before-slider').owlCarousel({
            loop: true,
            items: 1,
            margin: 10,
            nav: true,
            dots: true,
            navText: ['', ''],
            onInitialized() {
              const firstSlide = document.querySelector('#before-slider .gallery__item:first-child img');
              imgObserver.triggerLoad(firstSlide);

              new Promise((resolve) => {
                require.ensure(['./libs/fancybox/dist/jquery.fancybox.min.js'], () => {
                  resolve(require('./libs/fancybox/dist/jquery.fancybox.min.js'));
                }, 'jquery.fancybox.min');
              }).then(() => {
                  $('#before-slider .item').fancybox({
                    selector : '#before-slider .owl-item:not(.cloned) a',
                    backFocus : false,
                    infobar : false,
                    loop: true,
                    thumbs : {
                        autoStart : true,
                        axis : 'x'
                    }
                  });
              });
            }
        });
    });
  });
  await sleep(100);
  await import(
    /* webpackMode: "lazy" */
    /* webpackPreload: true */
    /* webpackChunkName: "before" */
    '../css/before.scss'
  ).then(() => {

    new Promise((resolve) => {
      require.ensure(['./spincrement.js'], () => {
        resolve(require('./spincrement.js'));
      }, 'spincrement');
    });

    $('#reviews-slider').owlCarousel({
        margin:10,
        responsiveClass:true,
        responsive:{
            0:{
              items:1
            },
            600:{
              items:1
            },
            1024:{
              items:2
            },
            1300:{
              items:3
            },
            1800:{
              items:3
            }
        }
    });
  });
  await sleep(100);
  await import(
    /* webpackMode: "lazy" */
    /* webpackPreload: true */
    /* webpackChunkName: "program" */
    '../css/program.scss'
  );
  await sleep(100);
  await import(
    /* webpackMode: "lazy" */
    /* webpackPreload: true */
    /* webpackChunkName: "speakers" */
    '../css/speakers.scss'
  );
  await sleep(100);
  await import(
    /* webpackMode: "lazy" */
    /* webpackPreload: true */
    /* webpackChunkName: "afterparty" */
    '../css/afterparty.scss'
  ).then(() => {
    setTimeout(() => {
      $('#afterparty-slider').owlCarousel({
          loop: true,
          items: 1,
          margin: 0,
          nav: true,
          dots: true,
          navText: ['', ''],
          center: true,
          responsive: {
            620: {
              items: 3,
              startPosition: 1
            },
            768: {
              items: 4
            }
          },
          onInitialized() {
            $('#afterparty-slider .item').fancybox({
                selector : '#afterparty-slider .owl-item:not(.cloned) a',
                backFocus : false,
                infobar : false,
                loop: true,
                thumbs : {
                    autoStart : true,
                    axis : 'x'
                }
            });

            $('#afterparty-slider .owl-item.cloned img').each(function() {
              $(this).attr('src', $(this).data('src')).removeAttr('data-src');
            });
          }
      });
    }, 1000);
  });
  await sleep(100);
  await import(
    /* webpackMode: "lazy" */
    /* webpackPreload: true */
    /* webpackChunkName: "community" */
    '../css/community.scss'
  ).then(() => {
    $('#community .carousel').owlCarousel({
        loop: false,
        margin: 15,
        nav: false,
        dots: true,
        dotsContainer: '#owl-dots',
        responsive:{
            0:{ items:2, stagePadding: 40 },
            500:{ items:3, stagePadding: 40 },
            700:{ items:4, stagePadding: 40 },
            900:{ items:5 },
            1200:{ items:6 },
            1400:{ items:7 }
        } 
    });
  });
  await sleep(100);
  await import(
    /* webpackMode: "lazy" */
    /* webpackPreload: true */
    /* webpackChunkName: "sponsors" */
    '../css/sponsors.scss'
  );
  await sleep(100);
  await import(
    /* webpackMode: "lazy" */
    /* webpackPreload: true */
    /* webpackChunkName: "contacts" */
    '../css/contacts.scss'
  );
  await sleep(100);
  await import(
    /* webpackMode: "lazy" */
    /* webpackPreload: true */
    /* webpackChunkName: "subscribe" */
    '../css/subscribe.scss'
  );
}

async function sleep(ms) {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}